/* eslint-disable max-len */
import React from "react";

const FolderIcon = (props: Record<string, any>) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 71 57" {...props}>
        <path fill="#0074A8" d="M70.243 36.586V3.714c0-1.93-1.45-3.437-3.2-3.437h-17.35c-1.022 0-1.98.515-2.576 1.43L45.6 4.014c-.595.916-1.554 1.431-2.575 1.431H13.367c-1.75 0-3.173 1.593-3.173 3.523v36.945c0 1.93 1.423 3.522 3.173 3.522h52.356l.269 1.438c0 1.165.96 2.1 2.126 2.1a2.131 2.131 0 0 0 2.125-2.119V36.586Z" />
        <path fill="#59CAFC" d="M68.118 52.966c-1.166 0-2.126-.942-2.126-2.108l-2.643-14.272h.002l-2.605-12.954c-.314-1.558-1.986-2.826-3.736-2.826H3.437A2.684 2.684 0 0 0 .81 24.019l.867 4.31 5.055 25.126c.313 1.558 1.986 2.822 3.736 2.822h53.676c.067 0 .131-.002.196-.006a5.638 5.638 0 0 0 5.811-4.807 2.133 2.133 0 0 1-2.033 1.502Z" />
    </svg>
);
FolderIcon.displayName = "FolderIcon";

export { FolderIcon };
